import { Enum, EnumType } from 'ts-jenum';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faStar, faVoicemail, faUsers, faRoute, faProjectDiagram } from '@fortawesome/pro-solid-svg-icons';

@Enum<QueueTypeEnum>('value')
export class QueueTypeEnum extends EnumType<QueueTypeEnum>() {
   static readonly SKILL = new QueueTypeEnum(1, 'Skill', faStar);
   static readonly HUNT = new QueueTypeEnum(3, 'Hunt-Group', faUsers);
   static readonly IVR = new QueueTypeEnum(4, 'IVR-Flow', faProjectDiagram);
   static readonly VOICEBOX = new QueueTypeEnum(5, 'Voice-Box', faVoicemail);
   static readonly ROUTETABLE = new QueueTypeEnum(6, 'Route-Table', faRoute);

   public static getQueueTypeFromSamwinValue(queueTypeId: number): QueueTypeEnum {
      try {
         const acdType = QueueTypeEnum.valueOf(queueTypeId);
         return acdType;
      } catch {}
      return QueueTypeEnum.SKILL;
   }

   private constructor(public value: number, public name: string, public icon: IconDefinition) {
      super();
   }
}
